var url = window.location.origin + "/images/"

export const IMAGE = {
    logo5:url + '512logo.png',
    logo:url + 'logo.png',
    seden:url + 'seden.png',
    delux:url + 'delux.png',
    custom:url + 'custom.png',
    plus_icon:url + 'plus_icon.png',
    cross_icon:url + 'cross_icon.png',
    pick_icon:url + 'pick_icon.png',
    location_fill:url + 'location-fill.png',
    darklogo:url + 'dark-logo.png',
}